import {CUSTOMER_NAME_TYPE_ENUM} from "@/constant/constants.ts";
import {useTranslation} from "react-i18next";

const CustomerRequestTypeTag = ({status}: { status?: number | null }) => {
    const {t} = useTranslation();

    let color = '#fafafa';
    if (status === CUSTOMER_NAME_TYPE_ENUM.FREE_TRIAL) {
        color = '#52c41a'
    } else if (status === CUSTOMER_NAME_TYPE_ENUM.APPLY_LICENSE) {
        color = '#1677ff'
    }

    const CUSTOMER_REQUEST_TYPE_MAP: Map<number, string> = new Map([
        [CUSTOMER_NAME_TYPE_ENUM.FREE_TRIAL, t('field.freeTrial')],
        [CUSTOMER_NAME_TYPE_ENUM.APPLY_LICENSE, t('field.applyALicense')]
    ])

    return (<>
        {
            status ?
                <span key={status} className={'w-[111px] text-center whitespace-nowrap'}>
                   <span style={{color: color}}>•</span> {CUSTOMER_REQUEST_TYPE_MAP.get(status)}
                </span> :
                <span>-</span>
        }
    </>)
}

export default CustomerRequestTypeTag;